export const AUTH_USERS_STORAGE_KEY = 'bookHubUsers';
export const AUTH_CURRENT_USER_STORAGE_KEY = 'bookHubCurrentUser';
export const AUTH_SESSION_TOKEN_KEY = 'bookHubSessionToken';
